import { XML_RenderChartBoxPDF } from "./XML_RenderChartBoxPDF";
import { XML_RenderChartBoxPPT } from "./XML_RenderChartBoxPPT";
import { enumXMLType } from "../constants";

export function XML_RenderChartBox(
  bounds,
  outerBounds,
  boxShape,
  fillMode,
  fillColor,
  borderStyle,
  borderThickness,
  borderColor,
  dashStyle,
  shadow,
  drawElement,
  theLayer,
  backColor
) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF)
    XML_RenderChartBoxPDF(
      bounds,
      outerBounds,
      boxShape,
      fillMode,
      fillColor,
      borderStyle,
      borderThickness,
      borderColor,
      dashStyle,
      shadow,
      drawElement,
      theLayer,
      backColor
    );
  else
    XML_RenderChartBoxPPT(
      bounds,
      outerBounds,
      boxShape,
      fillMode,
      fillColor,
      borderStyle,
      borderThickness,
      borderColor,
      dashStyle,
      shadow,
      drawElement,
      theLayer,
      backColor
    );
}
